import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  .circular-progress {
    position: relative;
    margin-bottom: 16px;
  }
  
  .circular-progress-circle {
    width: 100%;
    height: 100%;
    fill: none;
    stroke-linecap: round;
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
  }
  
  .circular-progress-background {
    stroke: ${(props) => props.theme.colors.text};
    stroke-opacity: 0.2;
  }
  
  .circular-progress-value {
    stroke: ${(props) => props.theme.colors.main_cta};
  }
  
  .circular-progress-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 36px;
    font-weight: bold;
    color: ${(props) => props.theme.colors.text};
  }
  
  .circular-progress-label {
    font-size: 16px;
    color: ${(props) => props.theme.colors.inactive};
    margin-top: 8px;
  }
`;

export default { Wrapper };
